import { NOTIFICATIONS_TYPE } from '../../constants/notificationsConstants'
angular
  .module('surfsightApp.controllers')
  .controller('healthReportsDataUsageController', [
    '$scope',
    '$timeout',
    '$interval',
    '$location',
    '$http',
    '$filter',
    '$localStorage',
    '$q',
    function (
      $scope,
      $timeout,
      $interval,
      $location,
      $http,
      $filter,
      $localStorage,
      $q
    ) {
      const $translate = $filter('translate')

      $scope.downloadDataUsageReportStatus = {
        inProgress: false,
        buttonText: 'Prepare download',
        url: ''
      }
      $scope.userOrganization = $localStorage.userOrganization
      $scope.currentTab = 0
      $scope.loading = false

      let tableApiRequestTimeout = null
      const initialPageSize = 100

      function splitAfterFive (input) {
        const firstPart = input.slice(0, 5)
        const rest = input.slice(5)
        return [firstPart, rest]
      }

      const dataThresholdSet = $translate('dataThresholdSet')
      const [dataThresholdSetFirst, dataThresholdSetLast] = splitAfterFive(
        dataThresholdSet
      )
      $scope.customHeaderName = {
        dataThresholdSetFirst,
        dataThresholdSetLast
      }

      const processDataUsage = dataUsages => {
        return dataUsages.map(usage => {
          return {
            ...usage,
            notificationEnabled: usage.notificationEnabled ? 'Yes' : 'No',
            thresholdSet: usage.thresholdSet ? 'Yes' : 'No',
            firmwareVersion:
              usage.firmwareVersion.length > 0 ? usage.firmwareVersion : '-'
          }
        })
      }

      const getDeviceDataUsageUrl = () => `${DEVICE_BASEURL}/device-data-usage`

      const getDeviceDataUsageDownloadUrl = () =>
        `${DEVICE_BASEURL}/device-data-usage-download`
      $scope.data = {}
      $scope.data.gridOptions = {
        data: [],
        urlSync: true,
        defaultPageSize: initialPageSize,
        pagination: {
          itemsPerPage: initialPageSize
        },
        getData: (params, callback) => {
          tableApiRequestTimeout && tableApiRequestTimeout.resolve()
          $scope.params = params
          const urlSearchParams = new URLSearchParams(params)
          const queryParamsIterator = urlSearchParams.entries()
          let requestQueryParams = new URLSearchParams('')

          requestQueryParams.set(
            'limit',
            urlSearchParams.get('itemsPerPage') ||
              $scope.data.gridOptions.defaultPageSize
          )
          requestQueryParams.set(
            'organizationId',
            $localStorage.userOrganization.id
          )

          for (const queryParam of queryParamsIterator) {
            const [key, value] = queryParam
            if (key === 'page') {
              const limit = requestQueryParams.get('limit')
              const offset = parseInt(limit) * (parseInt(value) - 1)
              offset && requestQueryParams.set('offset', offset)
            } else {
              requestQueryParams.set(key.replace(/grid_search\./, ''), value)
            }
          }
          if (requestQueryParams.get('serialNumber')) {
            requestQueryParams.set(
              'serialNumber',
              requestQueryParams.get('serialNumber')
            )
          }
          if (requestQueryParams.get('deviceName')) {
            requestQueryParams.set(
              'deviceName',
              requestQueryParams.get('deviceName')
            )
          }
          tableApiRequestTimeout = $q.defer()
          $scope.loading = true
          const requestJson = {
            method: 'GET',
            url: `${getDeviceDataUsageUrl()}?${requestQueryParams.toString()}`,
            timeout: tableApiRequestTimeout
          }
          $http(requestJson)
            .then(async ({ data: { devices, metadata } }) => {
              const dataUsages = processDataUsage(devices)
              callback(dataUsages, metadata.count)
              $scope.data.gridOptions.data = dataUsages
              $scope.data.gridOptions.totalItems = metadata.count
            })
            .catch(handleServerError)
            .finally(() => {
              $scope.loading = false
              $scope.$applyAsync()
            })
        }
      }

      $scope.downloadCurrentReport = () => {
        const urlSearchParams = new URLSearchParams($scope.params)
        const requestQueryParams = new URLSearchParams('')
        requestQueryParams.set(
          'organizationId',
          $localStorage.userOrganization.id
        )
        $scope.downloadDataUsageReportStatus = {
          inProgress: true,
          buttonText: 'Preparing...'
        }

        const requestJson = {
          method: 'GET',
          url: `${getDeviceDataUsageDownloadUrl()}?${requestQueryParams.toString()}`,
          timeout: tableApiRequestTimeout
        }

        $http(requestJson)
          .then(res => {
            $scope.downloadDataUsageReportStatus = {
              inProgress: false,
              buttonText: 'Prepare download'
            }
            $scope.$emit('reportDownloadRequested', {
              reportType:
                NOTIFICATIONS_TYPE.downloadDevicesDataUsageReport
                  .notificationType
            })
          })
          .catch(error => {
            console.error('Error getting report:', error)
            $scope.downloadDataUsageReportStatus = {
              inProgress: false,
              buttonText: 'Prepare download'
            }
          })
      }

      $scope.tableRefresh = function () {
        $scope.data.gridOptions.getData($scope.params, (data, count) => {
          $scope.data.gridOptions.data = data
          $scope.data.gridOptions.totalItems = count
          $scope.$applyAsync()
        })
      }
      $timeout(() => {
        $scope.tableRefresh()
      })
      const tableRefreshInterval = $interval(() => {
        $scope.tableRefresh()
      }, 60 * 1000)
      $scope.grid_search = {}
      const handleServerError = error => {
        $scope.$emit('handleServerError', error)
      }
      $scope.changeDateFormat = date => moment(date).format('MMM D YYYY')
      $scope.$on('$destroy', () => {
        $interval.cancel(tableRefreshInterval)
      })
      $scope.$watch('currentTab', function (newVal, oldVal) {
        if (newVal !== oldVal) {
          $scope.grid_search = {}
          const urlSearchParams = new URLSearchParams($location.search())
          const queryParamsIterator = urlSearchParams.entries()
          for (const queryParam of queryParamsIterator) {
            const [key] = queryParam
            if (key.startsWith('grid_search')) {
              urlSearchParams.delete(key)
            }
          }
          $location.search(urlSearchParams.toString())
          $scope.params = {}
          $scope.tableRefresh()
        }
      })
    }
  ])
